import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import '@/plugins/axios'
import '@/plugins/vue-error-handler'
import '@/plugins/moment'
import '@/plugins/vuejs-logger'
import '@/plugins/lodash'
import '@/plugins/googleChart'
import '@/plugins/BlurHash'
import '@/plugins/datetimepicker'

Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
